import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getPushAlarm, setPushAlarm } from '../../../../features/mobile/settingSlice';
import HeadCont from '../../components/common/HeadCont';
import ToggleBtn from '../../components/common/Toggle';
import { FirebaseMessaging } from '@capacitor-firebase/messaging';
import { Capacitor } from '@capacitor/core';

const Push = () => {
        const dispatch = useDispatch()
    const { loginInfo } = useSelector((state) => state.commonApp)

    const notificationTypes = [
        { key: "all_notifications", value: "pushOnAll" },
        { key: "notice_notifications", value: "pushOnNotice" },
        { key: "meal_record_notifications", value: "pushOnEatRecord" },
        { key: "health_record_notifications", value: "pushOnDiary" }
    ];
    const [toggle, setToggle] = useState({ pushOnAll: false, pushOnNotice: false, pushOnEatRecord: false, pushOnDiary: false })
    const [osPermissionGranted, setOsPermissionGranted] = useState(true)

    const onToggle = (paramValue) => {
        if (paramValue === "pushOnAll") {
            // Toggle All Notifications - turn all on or all off
            const newValue = !toggle.pushOnAll;
            const newToggle = {
                pushOnAll: newValue,
                pushOnNotice: newValue,
                pushOnEatRecord: newValue,
                pushOnDiary: newValue
            };
            setToggle(newToggle);
            // Update all notification types in database
            dispatch(setPushAlarm({
                userId: loginInfo.userId,
                pushOnAll: newValue,
                pushOnNotice: newValue,
                pushOnEatRecord: newValue,
                pushOnDiary: newValue
            }));
        } else {
            // Toggle individual notification
            const newValue = !toggle[paramValue];
            const newToggle = { ...toggle, [paramValue]: newValue };

            // If turning OFF any individual notification, turn OFF "All Notifications"
            if (!newValue && toggle.pushOnAll) {
                newToggle.pushOnAll = false;
            }

            // If ALL individual notifications are now ON, turn ON "All Notifications"
            if (newValue &&
                newToggle.pushOnNotice &&
                newToggle.pushOnEatRecord &&
                newToggle.pushOnDiary) {
                newToggle.pushOnAll = true;
            }

            setToggle(newToggle);
            dispatch(setPushAlarm({ userId: loginInfo.userId, [paramValue]: newValue }));
        }
    }

    useEffect(() => {
        // Check OS-level notification permission
        const checkOSPermission = async () => {
            if (Capacitor.isNativePlatform()) {
                try {
                    const result = await FirebaseMessaging.checkPermissions();
                    const granted = result.receive === 'granted';
                    setOsPermissionGranted(granted);

                    // If OS permission is denied, turn off all toggles
                    if (!granted) {
                        setToggle({
                            pushOnAll: false,
                            pushOnNotice: false,
                            pushOnEatRecord: false,
                            pushOnDiary: false
                        });
                    }
                    return granted;
                } catch (err) {
                    console.log('Error checking permissions:', err);
                    return true; // Assume granted on error (web platform)
                }
            }
            return true; // Web platform
        };

        const loadSettings = async () => {
            // Check OS permission first
            const hasOSPermission = await checkOSPermission();

            // Then load user preferences from database
            dispatch(getPushAlarm(loginInfo.userId))
                .unwrap()
                .then(res => {
                    if (res.ok) {
                        // Only apply user preferences if OS permission is granted
                        if (hasOSPermission) {
                            setToggle(res);
                        } else {
                            // OS permission denied, keep all toggles off
                            setToggle({
                                pushOnAll: false,
                                pushOnNotice: false,
                                pushOnEatRecord: false,
                                pushOnDiary: false
                            });
                        }
                    }
                })
                .catch(err => console.log(err));
        };

        loadSettings();

        // Check permission when app comes to foreground (user might have changed it in Settings)
        const handleVisibilityChange = () => {
            if (document.visibilityState === 'visible') {
                checkOSPermission();
            }
        };

        document.addEventListener('visibilitychange', handleVisibilityChange);

        return () => {
            document.removeEventListener('visibilitychange', handleVisibilityChange);
        };
    }, [dispatch, loginInfo.userId])

    return (
        <>
            <HeadCont rightIcon={'no icon'} transparent={'white'} title={"Notification Settings"} underline={true} />
            <section className='relative px-6 mb-6 safe-area-mt-header'>
                <ul>
                    {notificationTypes.map((item, idx) => (
                        <li className='p-4' key={idx}>
                            <ToggleBtn
                                isOn={toggle[item.value]}
                                onToggle={() => onToggle(item.value)}
                                title={item.key === "all_notifications" ? "All Notifications" :
                                       item.key === "notice_notifications" ? "Notice Notifications" :
                                       item.key === "meal_record_notifications" ? "Meal Record Reminders" :
                                       "Health Record Reminders"}
                                justifyB={true}
                            />
                        </li>
                    ))}
                </ul>
            </section>
        </>
    );
};

export default Push;